module.exports = __webpack_public_path__ + "static/media/24.0c1ceddf.jpg";